const initialState = {
	data: [],
	total: 0,
	params: {},
	selectedAffiliateCommissionLevel: {},
	sidebarOpen: false,
	sidebarStatus: 'add',
}

const commissionlevel = (state = initialState, action) => {
	switch (action.type) {
		case 'AFFILIATECOMMISSIONLEVEL_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		case 'AFFILIATECOMMISSIONLEVEL_ADD_DATA':
			return {
				...state,
				data: [...state.data, action.data],
				total: state.total + 1,
			}
		case 'AFFILIATECOMMISSIONLEVEL_UPDATE_DATA':
			return {
				...state,
				data: state.data.map((item) => (item.id === action.index ? action.data : item)),
			}
		case 'AFFILIATECOMMISSIONLEVEL_DEL_DATA':
			return {
				...state,
				data: state.data.filter((item) => item.id !== action.index),
				total: state.total - 1,
			}
		case 'AFFILIATECOMMISSIONLEVEL_GET_CURRENT':
			return {
				...state,
				selectedAffiliateCommissionLevel: action.selectedAffiliateCommissionLevel,
			}
		case 'AFFILIATECOMMISSIONLEVEL_SET_SIDEBAR':
			return {
				...state,
				sidebarStatus: action.status,
				sidebarOpen: !state.sidebarOpen,
			}
		default:
			return state
	}
}

export default commissionlevel
